var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.attributes),function(attribute){return _c('StringEntry',{key:attribute.id,attrs:{"label":_vm.getFullLabel(attribute),"value":_vm.getPropertyText(attribute),"name":attribute.key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }